import {
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
	ViewChild
}                                      from '@angular/core';
import { BaseComponent }               from '@core/bases/base-component/base.component';
import { PaginationComponent }         from '@shared/list-operations/components/pagination/pagination.component';
import {
	ISortData,
	SortOrderEnum
}                                      from '@shared/list-operations/components/sort-filter/sort-filter.model';
import { LIST_OPERATIONS_METADATA }    from '@shared/list-operations/config/list-operations.config';
import {
	FilterDatepickerType,
	FilterDateRangePickerType,
	FilterIdentifiersEnum,
	FilterListType,
	FilterOptionType,
	FilterSwitchType,
	FilterTextType,
	FilterType,
	FilterTypes,
	IActiveFilterData,
	IActiveFilters,
	IFilter
}                                      from '@shared/list-operations/model/filter.model';
import {
	IListOperationsConfig,
	IRestoreListOperationsData,
	ListOperations,
	listOperationsDefaults,
	ListOperationsIdentifierEnum
}                                      from '@shared/list-operations/model/list-operations.model';
import {
	IPaging,
	IPagingData
}                                      from '@shared/list-operations/model/paging.model';
import { ISearchData }                 from '@shared/list-operations/model/search.model';
import { ListOperationsHelperService } from '@shared/list-operations/services/list-operations-helper.service';
import { ListOperationsService }       from '@shared/list-operations/services/list-operations.service';
import { ObjectUtils }                 from '@utils/helpers';
import { Subscription }                from 'rxjs';
import {
	take,
	takeUntil,
	takeWhile
}                                      from 'rxjs/operators';

@Component( {
	selector: 'app-list-operations-list-header',
	templateUrl: './list-operations-list-header.component.html',
	styleUrls: [ './list-operations-list-header.component.scss' ],
	providers: [ ListOperationsHelperService ]
} )
export class ListOperationsListHeaderComponent extends BaseComponent implements OnInit {

	private _componentIsInitialized = false;	// might not be necessary after full integration of re-worked list ops anymore

	private _subscriptions: Subscription[] = [];

	private _allListOperatorsAreInitialized: boolean;

	// ############ modified C-&-P from 'old' ListOperationsComponent ############

	private _search: string[];

	private _sort: string;

	private _activeFilters: IActiveFilters;


	private _checkedInitializationPreCondition: boolean;

	private _searchIsInitialized: boolean;

	private _sortIsInitialized: boolean;

	private _filterIsInitialized: boolean;

	private _pagingIsInitialized: boolean;


	private _listOperationsData: ListOperations;

	private _listOperationsConfigData: IListOperationsConfig;

	private _prevPageNumber: number;

	// --- render ---
	private _renderListOperations = true;

	private _renderSearch: boolean;

	private _renderSort: boolean;

	private _renderFilter: boolean;

	private _renderPagination = true;

	// --- hide ---
	private _hideSearch: boolean;

	private _hideSort: boolean;

	private _hideFilter: boolean;

	private _hidePagination = false;


	paging: IPaging;

	fallbackPaging: IPaging = {
		pageNumber: LIST_OPERATIONS_METADATA?.default?.paging?.pageNumber ?? 0,
		pageSize: LIST_OPERATIONS_METADATA?.default?.paging?.pageSize ?? 20
	};

	// individual operators comps data ###########################################

	pagingData: IPagingData;

	// not yet in use
	@Output() sidebarItemEmitter: EventEmitter<any> = new EventEmitter();


	// full layout / entity list page comp #######################################
	@Input( 'listOperationsConfigData' )
	set listOperationsConfigData( listOperationsConfigData: IListOperationsConfig ) {

		if ( !listOperationsConfigData ) { return; }

		this.reset();

		this._listOperationsConfigData = ObjectUtils.deepCopyByRecursion<IListOperationsConfig>( listOperationsConfigData );

		if ( this._componentIsInitialized ) {
			this.prepareConfigData();
		}
	}

	@Input() hideListOperations = false;

	@Output() operationEmitter: EventEmitter<ListOperationsIdentifierEnum> = new EventEmitter();


	// getters and setters for render and hide ###################################
	get renderListOperations(): boolean {
		return this._renderListOperations && !!this._listOperationsConfigData;
	}

	@Input() set renderListOperations( renderListOperations: boolean ) {
		this._renderListOperations = renderListOperations;
	}

	get renderSearch(): boolean {
		return this._renderSearch;
	}

	@Input() set renderSearch( renderSearch: boolean ) {
		this._renderSearch = renderSearch ?? listOperationsDefaults.renderSearch;
		this.listOperationsService.state.renderSearchSet(
			this._listOperationsConfigData.id,
			renderSearch,
			'ListOperationsListHeaderComponent:set renderSearch'
		);
	}

	get renderSort(): boolean {
		return this._renderSort;
	}

	@Input() set renderSort( renderSort: boolean ) {
		this._renderSort = renderSort ?? listOperationsDefaults.renderSort;
		this.listOperationsService.state.renderSortSet(
			this._listOperationsConfigData.id,
			renderSort,
			'ListOperationsListHeaderComponent:set renderSort'
		);
	}

	get renderFilter(): boolean {
		return this._renderFilter;
	}

	@Input() set renderFilter( renderFilter: boolean ) {
		this._renderFilter = renderFilter ?? listOperationsDefaults.renderFilter;
		this.listOperationsService.state.renderFilterSet(
			this._listOperationsConfigData.id,
			renderFilter,
			'ListOperationsListHeaderComponent:set renderFilter'
		);
	}

	get renderPagination(): boolean {
		return this._renderPagination;
	}

	@Input() set renderPagination( renderPagination: boolean ) {
		this._renderPagination = renderPagination ?? listOperationsDefaults.renderPagination;
	}

	get hideSearch(): boolean {
		return this._hideSearch;
	}

	@Input() set hideSearch( hideSearch: boolean ) {
		this._hideSearch = hideSearch ?? listOperationsDefaults.hideSearch;
		this.listOperationsService.state.hideSearchSet(
			this._listOperationsConfigData.id,
			hideSearch,
			'ListOperationsListHeaderComponent:set hideSearch'
		);
	}

	get hideSort(): boolean {
		return this._hideSort;
	}

	@Input() set hideSort( hideSort: boolean ) {
		this._hideSort = hideSort ?? listOperationsDefaults.hideSort;
		this.listOperationsService.state.hideSortSet(
			this._listOperationsConfigData.id,
			hideSort,
			'ListOperationsListHeaderComponent:set hideSort'
		);
	}

	get hideFilter(): boolean {
		return this._hideFilter;
	}

	@Input() set hideFilter( hideFilter: boolean ) {
		this._hideFilter = hideFilter ?? listOperationsDefaults.hideFilter;
		this.listOperationsService.state.hideFilterSet(
			this._listOperationsConfigData.id,
			hideFilter,
			'ListOperationsListHeaderComponent:set hideFilter'
		);
	}

	get hidePagination(): boolean {
		return this._hidePagination;
	}

	@Input() set hidePagination( hidePagination: boolean ) {
		this._hidePagination = hidePagination ?? listOperationsDefaults.hidePagination;
	}


	@ViewChild( 'paginationCmp' ) paginationCmp: PaginationComponent;


	constructor(
		private listOperationsHelperService: ListOperationsHelperService,
		public readonly listOperationsService: ListOperationsService
	) {
		super();
	}

	/*
	 * ############################ --- NEW CODE --- ############################
	 *
	 * Should replace the 'ngOnDestroy()' in the ListOperationsListHelperService
	 * (so 'clearListOperation()' has to move over to here)
	 */
	// tslint:disable-next-line:use-lifecycle-interface
	// ngOnDestroy() {
	// 	super.ngOnDestroy();
	// 	this.reset();
	// 	this.listOperationsHelperService.clearListOperation();
	// }

	/**
	 * Resets the component (i.e. some important instance variables).
	 * Necessary at least in test page because mocked entity list page
	 * components won't "die" (and subscriptions that were not unsubscribed will
	 * "survive" anyway!).
	 */
	private reset(): void {

		this._allListOperatorsAreInitialized = false;
		this._checkedInitializationPreCondition = undefined;

		this._search = undefined;
		this._searchIsInitialized = undefined;
		this._sort = undefined;
		this._sortIsInitialized = undefined;
		this._activeFilters = undefined;
		this._filterIsInitialized = undefined;
		this._pagingIsInitialized = undefined;

		this._subscriptions?.forEach(
			( subscription: Subscription ) => subscription.unsubscribe()
		);
		this._subscriptions = [];
	}

	private prepareConfigData(): void {

		if ( !this._componentIsInitialized || !this._listOperationsConfigData ) { return; }

		this.listOperationsService.select.restoreListOperationsData(
			this._listOperationsConfigData.id,
			'ListOperationsListHeaderComponent: prepareConfigData',
			true
		)
		.pipe(
			take( 1 ),
			takeUntil( this.ngUnsubscribe )
		)
		.subscribe( ( restoreData: IRestoreListOperationsData ) => {

			this.logger.log( 'current restore data:', restoreData );

			this.init( restoreData );
		} );
	}

	private init( restoreData?: IRestoreListOperationsData ): void {
		this.listOperationsHelperService.clearListOperation();
		/*
		 * TODO Implementation of this LisOpsHelperService method should change
		 * after full integration of re-worked list ops, because the callback now
		 * is included in the config data which makes the 3rd parameter redundant.
		 */
		this.listOperationsHelperService.initListOperation(
			this._listOperationsConfigData,
			'ListOperationsListHeaderComponent:init',
			this._listOperationsConfigData?.listOperationsConfigDataMap?.callback
		);

		this.listOperationsHelperService.listOperationsConfigData$
		.pipe(
			take( 1 ),
			takeUntil( this.ngUnsubscribe )
		)
		.subscribe( ( listOperationsConfig: IListOperationsConfig ) => {

			// default data
			this.initializeListOperationsData( listOperationsConfig );

			// restore data
			if ( restoreData?.operatorsData && restoreData.shouldRestoreData ) {
				this.restoreListOperationsData( restoreData );
			}

			// updates list ops state in ngrx store via ListOperationsHelperService
			this.listOperationsHelperService.onListOperationChange(
				{
					id: this._listOperationsConfigData.id,
					configData: this._listOperationsConfigData,
					hideFilter: this._hideFilter ?? listOperationsDefaults.hideFilter,
					hideSearch: this._hideSearch ?? listOperationsDefaults.hideSearch,
					hideSort: this._hideSort ?? listOperationsDefaults.hideSort,
					renderFilter: this._renderFilter ?? listOperationsDefaults.renderFilter,
					renderSearch: this._renderSearch ?? listOperationsDefaults.renderSearch,
					renderSort: this._renderSort ?? listOperationsDefaults.renderSort
				},
				'ListOperationsListHeaderComponent:init'
			);

			this.subscribeToListOperationsState();
		} );
	}

	private subscribeToListOperationsState(): void {

		// SEARCH
		this._subscriptions.push(
			this.listOperationsService.select.search(
				this._listOperationsConfigData.id, 'ListOperationsListHeaderComponent:subscribeToListOpsState'
			)
			.pipe( takeUntil( this.ngUnsubscribe ) )
			.subscribe( ( search: string[] ) => {
				this._search = [ ...search ?? [] ];
				this.onListOperatorDataChange();
			} )
		);

		this._subscriptions.push(
			this.listOperationsService.select.searchIsInitialized(
				this._listOperationsConfigData.id, 'ListOperationsListHeaderComponent:subscribeToListOpsState'
			)
			.pipe(
				takeWhile( ( searchIsInitialized: boolean ) => !!searchIsInitialized ),
				takeUntil( this.ngUnsubscribe )
			)
			.subscribe( ( searchIsInitialized: boolean ) => {
				this._searchIsInitialized = searchIsInitialized;
				this.onListOperatorInitializationFinish();
			} )
		);

		// SORT
		this._subscriptions.push(
			this.listOperationsService.select.sort(
				this._listOperationsConfigData.id, 'ListOperationsListHeaderComponent:subscribeToListOpsState'
			)
			.pipe( takeUntil( this.ngUnsubscribe ) )
			.subscribe( ( sort: string ) => {
				this._sort = sort;
				this.onListOperatorDataChange();
			} )
		);

		this._subscriptions.push(
			this.listOperationsService.select.sortIsInitialized(
				this._listOperationsConfigData.id, 'ListOperationsListHeaderComponent:subscribeToListOpsState'
			)
			.pipe(
				takeWhile( ( sortIsInitialized: boolean ) => !!sortIsInitialized ),
				takeUntil( this.ngUnsubscribe )
			)
			.subscribe( ( sortIsInitialized: boolean ) => {
				this._sortIsInitialized = sortIsInitialized;
				this.onListOperatorInitializationFinish();
			} )
		);

		// FILTER
		this._subscriptions.push(
			this.listOperationsService.select.activeFilters(
				this._listOperationsConfigData.id, 'ListOperationsListHeaderComponent:subscribeToListOpsState'
			)
			.pipe( takeUntil( this.ngUnsubscribe ) )
			.subscribe( ( activeFilters: IActiveFilters ) => {
				this._activeFilters = { ...activeFilters };
				this.onListOperatorDataChange();
			} )
		);

		this._subscriptions.push(
			this.listOperationsService.select.filterIsInitialized(
				this._listOperationsConfigData.id, 'ListOperationsListHeaderComponent:subscribeToListOpsState'
			)
			.pipe(
				takeWhile( ( filterIsInitialized: boolean ) => !!filterIsInitialized ),
				takeUntil( this.ngUnsubscribe )
			)
			.subscribe( ( filterIsInitialized: boolean ) => {
				this._filterIsInitialized = filterIsInitialized;
				this.onListOperatorInitializationFinish();
			} )
		);

		// PAGING
		this._subscriptions.push(
			this.listOperationsService.select.paging(
				this._listOperationsConfigData.id, 'ListOperationsListHeaderComponent:subscribeToListOpsState'
			)
			.pipe( takeUntil( this.ngUnsubscribe ) )
			.subscribe( ( paging: IPaging ) => {
				this.paging = { ...paging };
				if ( !paging?.blockOperationEmit ) { this.onListOperatorDataChange(); }
			} )
		);

		this._subscriptions.push(
			this.listOperationsService.select.pagingIsInitialized(
				this._listOperationsConfigData.id, 'ListOperationsListHeaderComponent:subscribeToListOpsState'
			)
			.pipe(
				takeWhile( ( pagingIsInitialized: boolean ) => !!pagingIsInitialized ),
				takeUntil( this.ngUnsubscribe )
			)
			.subscribe( ( pagingIsInitialized: boolean ) => {
				this._pagingIsInitialized = pagingIsInitialized;
				this.onListOperatorInitializationFinish();
			} )
		);
	}

	private initializeListOperationsData( listOperationsConfig: IListOperationsConfig ): void {
		let filterData: IFilter[];
		let pagingData: IPagingData;
		let searchData: ISearchData;
		let sortData: ISortData[];

		if ( Object.keys( listOperationsConfig?.searchData ?? {} ).length ) {
			searchData = listOperationsConfig?.searchData;
		} else {
			this._searchIsInitialized = true;
		}

		if ( listOperationsConfig?.sortData?.length ) {
			sortData = listOperationsConfig?.sortData;
		} else {
			this._sortIsInitialized = true;
		}

		if ( listOperationsConfig?.filterData?.length ) {
			filterData = listOperationsConfig?.filterData.map( ( filter: IFilter, filterIndex: number ) => {
				return { ...filter, id: filterIndex };
			} );
		} else {
			this._filterIsInitialized = true;
		}

		if ( Object.keys( listOperationsConfig?.pagingData ?? {} ).length ) {
			pagingData = listOperationsConfig?.pagingData;
			this.pagingData = pagingData;
		} else {
			this._pagingIsInitialized = true;
		}

		this._listOperationsConfigData = {
			...listOperationsConfig,
			filterData,
			activeData: {
				searchData,
				sortData,
				filterData,
				pagingData
			},
			defaultData: {
				searchData: ObjectUtils.deepCopyByRecursion<ISearchData>( searchData ),
				sortData: ObjectUtils.deepCopyByRecursion<ISortData[]>( sortData ),
				filterData: ObjectUtils.deepCopyByRecursion<IFilter[]>( filterData ),
				pagingData: ObjectUtils.deepCopyByRecursion<IPagingData>( pagingData )
			}
		};
	}

	private restoreListOperationsData( restoreListOperationsData: IRestoreListOperationsData ): void {
		const operatorsRestoreData = restoreListOperationsData?.operatorsData;
		let filterData: IFilter[];
		let pagingData: IPagingData;
		let searchData: ISearchData;
		let sortData: ISortData[];

		// SEARCH
		if ( operatorsRestoreData?.search ) {
			searchData = {
				...this._listOperationsConfigData?.activeData?.searchData,
				values: operatorsRestoreData?.search
			};
		}

		// SORT
		if ( operatorsRestoreData?.sort ) {
			const [ sortField, sortOrder ] = operatorsRestoreData?.sort.split( ',' );
			sortData = [];
			this._listOperationsConfigData?.activeData?.sortData?.forEach( ( sortItem: ISortData ) => {
				if ( sortItem.name === sortField ) {
					sortItem.defaultActive = true;
					if ( sortOrder ) { sortItem.sortOrder = sortOrder as SortOrderEnum; }
				} else {
					delete sortItem?.defaultActive;
					delete sortItem?.sortOrder;
				}

				sortData.push( sortItem );
			} );
		}

		// FILTER
		if ( operatorsRestoreData?.activeFilters ) {
			filterData = [];
			this._listOperationsConfigData?.activeData?.filterData?.forEach( ( filterItem: IFilter, filterIndex: number ) => {
				const activeFilterEntries = Object.entries( operatorsRestoreData?.activeFilters );
				const [ activeFilterIdentifier, activeFilterData ]: [ FilterIdentifiersEnum, IActiveFilterData ] =
					(
						activeFilterEntries.find(
							(
								[ activeFilterIdKey, activeFilterDataValue ]: [ FilterIdentifiersEnum, IActiveFilterData ]
							) => filterItem.filterId === activeFilterIdKey
						) ?? []
					) as [ FilterIdentifiersEnum, IActiveFilterData ];

				const filterValues = activeFilterData?.restoreValue
														 ? activeFilterData?.restoreValue
														 : activeFilterData?.param;

				if ( activeFilterIdentifier ) {
					filterItem.values = [];
					switch ( filterItem.type ) {

						case FilterTypes.FILTER_DATE_PICKER_TYPE:
							filterItem.values = [ filterValues as FilterDatepickerType[] ];
							break;

						// TODO extend with other FilterTypes on need
						case FilterTypes.FILTER_DATE_RANGE_PICKER_TYPE:
							filterItem.values = [ filterValues as FilterDateRangePickerType ];
							break;

						case FilterTypes.FILTER_LIST_TYPE:
							filterItem.values = filterValues as FilterListType[];
							break;

						case FilterTypes.FILTER_OPTION_TYPE:
							filterItem.values = filterValues as FilterOptionType[];
							break;

						case FilterTypes.FILTER_SELECT_ARCHIVING_ERS_TYPE:
						case FilterTypes.FILTER_SELECT_ARCHIVING_TSS_TYPE:
						case FilterTypes.FILTER_SELECT_BUSINESS_PREMISES_TYPE:
						case FilterTypes.FILTER_SELECT_ERS_TYPE:
						case FilterTypes.FILTER_SELECT_ORGANIZATION_TYPE:
						case FilterTypes.FILTER_SELECT_TSS_TYPE:
							filterItem.selectFilter.search = filterValues as string;
							break;

						case FilterTypes.FILTER_SWITCH_TYPE:
							filterItem.values = [ filterValues as FilterSwitchType[] ];
							break;

						case FilterTypes.FILTER_TEXT_TYPE:
							filterItem.values = [ filterValues as FilterTextType ];
							break;
					}
				}

				filterData.push(
					{
						...filterItem,
						id: filterIndex
					}
				);
			} );
		}

		// PAGING
		if ( operatorsRestoreData?.paging ) {
			pagingData = {
				...this._listOperationsConfigData?.activeData?.pagingData,
				defaultValues: {
					pageNumber: operatorsRestoreData?.paging?.pageNumber,
					pageSize: this._listOperationsConfigData.activeData?.pagingData?.defaultValues?.pageSize
				}
			};
		}

		this._listOperationsConfigData = {
			...this._listOperationsConfigData,
			filterData,
			activeData: {
				searchData,
				sortData,
				filterData,
				pagingData
			},
			restoreData: {
				searchData: ObjectUtils.deepCopyByRecursion<ISearchData>( searchData ),
				sortData: ObjectUtils.deepCopyByRecursion<ISortData[]>( sortData ),
				filterData: ObjectUtils.deepCopyByRecursion<IFilter[]>( filterData ),
				pagingData: ObjectUtils.deepCopyByRecursion<IPagingData>( pagingData )
			}
		};
	}

	private resetListOperationsData() {
		const defaultPaging = { ...this.pagingData?.defaultValues } ?? this.fallbackPaging;

		this._listOperationsData = {
			id: this._listOperationsData?.id,
			sort: null,
			search: [],
			activeFilters: {},
			paging: defaultPaging
		};

		this._prevPageNumber = 0;
	}

	private onListOperatorInitializationFinish(): void {

		const filterData: FilterType[] = this._listOperationsConfigData?.activeData?.filterData;
		const pagingData: IPagingData = this._listOperationsConfigData?.activeData?.pagingData;
		const searchData: ISearchData = this._listOperationsConfigData?.activeData?.searchData;
		const sortData: ISortData[] = this._listOperationsConfigData?.activeData?.sortData;

		// set as initialized when render is false or no configData exists
		if ( !this._checkedInitializationPreCondition ) {
			this._checkedInitializationPreCondition = true;
			this._searchIsInitialized = this._searchIsInitialized || !this.renderSearch || !searchData;
			this._sortIsInitialized = this._sortIsInitialized || !this.renderSort || !sortData;
			this._filterIsInitialized = this._filterIsInitialized || !this.renderFilter || !filterData;
			this._pagingIsInitialized = this._pagingIsInitialized || !this.renderPagination || !pagingData;
		}

		if ( this._filterIsInitialized && this._searchIsInitialized && this._sortIsInitialized && this._pagingIsInitialized ) {
			this._allListOperatorsAreInitialized = true;
			this.onOperationEmitter();
		}
	}

	private onListOperatorDataChange(): void {

		if (
			this.listOperationsHelperService.isOnDestroy
			|| !this._allListOperatorsAreInitialized
		) { return; }

		this.onOperationEmitter();
	}

	private onOperationEmitter() {

		const search = this._search;
		const sort = this._sort;
		const filters = this._activeFilters;
		const newPageNumber = this.paging?.pageNumber;

		// check for existing list operations
		let activeListOperationExist = false;

		if ( this._prevPageNumber !== newPageNumber ) {
			activeListOperationExist = true;
			this._prevPageNumber = newPageNumber;
		}
		if ( !activeListOperationExist && search && search.length > 0 ) { activeListOperationExist = true; }
		if ( !activeListOperationExist && sort && sort.length > 0 ) { activeListOperationExist = true; }
		if ( !activeListOperationExist && filters && Object.keys( filters ).length > 0 ) { activeListOperationExist = true; }

		if ( !activeListOperationExist ) {
			this.resetListOperationsData();     // WHY this call at all ???
		}

		const restoreListOperationsData: IRestoreListOperationsData =
			activeListOperationExist
			? {
					operatorsData: {
						search: this._search,
						sort: this._sort,
						activeFilters: this._activeFilters
													 ? { ...this._activeFilters }
													 : {},
						paging: this.paging
										? { ...this.paging }
										: null
					},
					shouldRestoreData: false
				}
			: null;

		/*
		 * (initializes and) updates restore (sub-)state in store each time a list
		 * operator data value changes
		 */
		this.listOperationsService.state.restoreListOperationsDataSet(
			this._listOperationsConfigData.id,
			restoreListOperationsData,
			'ListOperationsListHeaderComponent:onOperationEmitter->setRestoreDataInStore'
		);

		this.operationEmitter.emit( this._listOperationsConfigData.id );
	}

	ngOnInit(): void {
		this._componentIsInitialized = true;
		this.prepareConfigData();
	}

	onOperationPaginationEmitter( paging: IPaging, isOperationChange?: boolean ) {
		const timeout = setTimeout( () => {
			clearTimeout( timeout );
			this.listOperationsService.state.pagingSet(
				this._listOperationsConfigData.id,
				{ ...paging },
				'ListOperationsListHeaderComponent:onOperationPaginationEmitter->operatorConfigHasChanged'
			);

			if ( !isOperationChange ) {

				// set 'pagingIsInitialized' in Store instead of directly locally :
				this.listOperationsService.state.pagingIsInitializedSet(
					this._listOperationsConfigData.id,
					true,
					'ListOperationsListHeaderComponent:onOperationPaginationEmitter->operatorInitialization'
				);
			}
		}, 0 );
	}
}
